import { zeroToastStyles as styles } from '@genesislcap/foundation-zero';
import { css, ElementStyles } from '@microsoft/fast-element';
import { mixinRobotoMedium, mixinRobotoRegular } from '../../../styles';
import { MainStyles } from '../../../main/main.styles';

export const customToastStyles: ElementStyles = css`
  ${styles}
  ${MainStyles}
  

  :host ::slotted([slot='top']) {
    margin-left: 4px;
    margin-bottom: 4px;
    font-size: 14px;
    line-height: 20px;
    color: #f1f1f1;
    ${mixinRobotoMedium()}
  }

  :host ::slotted([slot='content']) {
    font-size: 13px;
    line-height: 20px;
    margin-left: 4px;
    color: #c9c9c9;
    ${mixinRobotoRegular}
  }

  :host::part(date) {
    margin: 0;
    color: #879ba6;
    ${mixinRobotoRegular}
  }

  :host::part(content) {
    width: 100%;
  }

  :host ::slotted([slot='date']) {
    font-size: 12px;
    line-height: 16px;
    margin-left: 4px;
    color: var(--nest-level-tab-font);
    ${mixinRobotoRegular}
  }

  :host([notify='success']) .toast::after,
  :host([notify='information']) .toast::after {
    background-color: rgba(72, 232, 154, 1);
  }

  :host([notify='warning']) .toast::after {
    background-color: rgba(255, 182, 96, 1);
  }

  :host([notify='error']) .toast::after,
  :host([notify='serious']) .toast::after {
    background-color: rgba(249, 100, 77, 1);
  }

  :host::part(bottom) {
    width: auto;
    display: flex;
    flex-direction: row;
    gap: 12px;
    margin-top: 5px;
    padding-left: 4px;
  }
`;
